"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var text_1 = require("./text");
function TextareaDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/textarea.html',
        controller: /** @class */ (function (_super) {
            __extends(TextareaController, _super);
            function TextareaController($scope, book) {
                'ngInject';
                return _super.call(this, $scope, book) || this;
            }
            return TextareaController;
        }(text_1.TextController)),
        controllerAs: 'textareaCtrl'
    };
}
exports.TextareaDirective = TextareaDirective;
